import React, { useEffect, useState } from "react";
import CandidateCard from "./candidateCard";
import { ClientFolderService } from "../../../services/clientFolderService";
import { decodeJWT } from "../../../services/candidateService";
import { ClientService } from "../../../services/clientService";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersSlash } from "@fortawesome/free-solid-svg-icons";
const CandidateGrid = ({
    loading,
    candidates,
    currentPage,
    totalPages,
    onPageChange,
    tabType,
    preserveState,
    onCandidateMoved,
    selectedFolder
}) => {
    const decoded = decodeJWT(localStorage.getItem("authToken"));
    const clientId = _.get(decoded, "clientId", "");
    const [openMenuCandidateId, setOpenMenuCandidateId] = useState(null);
    const [showRemovePopup, setShowRemovePopup] = useState(false);
    const [candidateToRemove, setCandidateToRemove] = useState(null);
    const [removeLoading, setRemoveLoading] = useState(false);

    useEffect(() => {
        const handleClickOutside = () => {
            setOpenMenuCandidateId(null);
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    if (loading) return <div className="loader">Loading...</div>;
    if (!candidates.length) {
        return (
            <div className="no-candidates-container">
                <FontAwesomeIcon
                    icon={faUsersSlash}
                    className="no-candidates-icon"
                />

                <h5>No candidates found in this folder.</h5>
            </div>
        );
    }

    const openNewFolderPopup = () => {
        setShowPopup(false);
        setShowNewFolderPopup(true);
    };
    const handleCreateFolder = (updatedFolders) => {
        setFolders(
            updatedFolders.map(f => ({
                folderId: f.folderId,
                name: f.name
            }))
        );

        setShowNewFolderPopup(false);
        setShowPopup(true);
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            const start = Math.max(1, currentPage + 1 - 2);
            const end = Math.min(totalPages, start + maxVisible - 1);

            if (start > 1) pages.push(1, '...');
            for (let i = start; i <= end; i++) pages.push(i);
            if (end < totalPages) pages.push('...', totalPages);
        }

        return pages;
    };

    const handleRemoveConfirm = async () => {
        if (!candidateToRemove || !selectedFolder) return;

        try {
            setRemoveLoading(true);

            await ClientService.removeShortlistCandidate(
                candidateToRemove.candidateId,
                selectedFolder.folderId
            );

            setShowRemovePopup(false);
            setCandidateToRemove(null);
            onCandidateMoved?.();
            onPageChange(0);
        } catch (err) {
            console.error("Failed to remove candidate", err);
        } finally {
            setRemoveLoading(false);
        }
    };

    return (
        <>
            <div className="candidate-grid">
                {candidates.map(candidate => (
                    <CandidateCard
                        key={candidate.candidateId}
                        candidate={candidate}
                        tabType={tabType}
                        preserveState={preserveState}
                        isMenuOpen={openMenuCandidateId === candidate.candidateId}
                        onMenuToggle={(e) => {
                            e.stopPropagation();
                            setOpenMenuCandidateId(prev =>
                                prev === candidate.candidateId ? null : candidate.candidateId
                            );
                        }}
                        onRemoveClick={(c) => {
                            setOpenMenuCandidateId(null);
                            setCandidateToRemove(c);
                            setShowRemovePopup(true);
                        }}
                    />
                ))}
            </div>


            {totalPages > 1 && candidates.length > 0 && (
                <div className="d-flex justify-content-center my-3">
                    <div className="pagination-container">
                        <button
                            onClick={() => onPageChange(0)}
                            disabled={currentPage === 0}
                        >
                            {'<<'}
                        </button>

                        <button
                            onClick={() => onPageChange(Math.max(currentPage - 1, 0))}
                            disabled={currentPage === 0}
                        >
                            {'<'}
                        </button>

                        {renderPageNumbers().map((page, index) => (
                            <button
                                key={index}
                                className={`border rounded p-1 ${currentPage + 1 === page ? 'active' : ''
                                    }`}
                                onClick={() => {
                                    if (typeof page === 'number') {
                                        onPageChange(page - 1);
                                    }
                                }}
                                disabled={typeof page !== 'number'}
                            >
                                {page}
                            </button>
                        ))}

                        <button
                            onClick={() =>
                                onPageChange(Math.min(currentPage + 1, totalPages - 1))
                            }
                            disabled={currentPage >= totalPages - 1}
                        >
                            {'>'}
                        </button>

                        <button
                            onClick={() => onPageChange(totalPages - 1)}
                            disabled={currentPage >= totalPages - 1}
                        >
                            {'>>'}
                        </button>
                    </div>
                </div>
            )}

            {showRemovePopup && (
                <div className="folder-modal-overlay">
                    <div className="folder-modal">
                        <h4>Remove Candidate</h4>
                        <p>
                            Are you sure you want to remove this candidate from
                            <strong> Shortlisted list</strong>?
                        </p>

                        <div className="modal-actions">
                            <button
                                onClick={() => {
                                    setShowRemovePopup(false);
                                    setCandidateToRemove(null);
                                }}
                            >
                                Cancel
                            </button>

                            <button
                                style={{ background: "red", color: "#fff" }}
                                onClick={handleRemoveConfirm}
                                disabled={removeLoading}
                            >
                                {removeLoading ? "Removing..." : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default CandidateGrid;
